"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  hover: 0,
  autoPlay: 1,
  click: 2,
  refactoredAutoPlay: 'auto'
};
exports["default"] = _default;